import React from "react";
import { LayoutTypes, useLayoutType } from "@/util-react/layout";
import { LogisticAndDeliveryDesktop } from "@/elements-react/logistic-and-delivery/logistic.desktop";
import { LogisticAndDeliveryMobile } from "@/elements-react/logistic-and-delivery/logistic.mobile";

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return LogisticAndDeliveryDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return LogisticAndDeliveryMobile;
  }
};

export const LogisticAndDelivery: React.FC = () => {
  const { layoutType } = useLayoutType();
  const PageComponent = getPageComponent(layoutType);

  return <PageComponent />;
};
